"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetRuntimeEnv = exports.WidgetInstallEnv = exports.WidgetPackageStatus = exports.WidgetReleaseType = exports.WidgetPackageType = void 0;
var WidgetPackageType;
(function (WidgetPackageType) {
    WidgetPackageType[WidgetPackageType["Custom"] = 0] = "Custom";
    WidgetPackageType[WidgetPackageType["Official"] = 1] = "Official";
})(WidgetPackageType = exports.WidgetPackageType || (exports.WidgetPackageType = {}));
var WidgetReleaseType;
(function (WidgetReleaseType) {
    /**
     * space self-created
     */
    WidgetReleaseType[WidgetReleaseType["Space"] = 0] = "Space";
    /**
     * official recommend
     */
    WidgetReleaseType[WidgetReleaseType["Global"] = 1] = "Global";
    /**
     * censorship preview
     */
    WidgetReleaseType[WidgetReleaseType["Preview"] = 10] = "Preview";
})(WidgetReleaseType = exports.WidgetReleaseType || (exports.WidgetReleaseType = {}));
var WidgetPackageStatus;
(function (WidgetPackageStatus) {
    /**
     * under development
     */
    WidgetPackageStatus[WidgetPackageStatus["Developing"] = 0] = "Developing";
    /**
     * Banned(forbidden)
     */
    WidgetPackageStatus[WidgetPackageStatus["Ban"] = 1] = "Ban";
    /**
     * Published
     */
    WidgetPackageStatus[WidgetPackageStatus["Published"] = 3] = "Published";
    /**
     * Unpublished(down)
     */
    WidgetPackageStatus[WidgetPackageStatus["Unpublished"] = 4] = "Unpublished";
})(WidgetPackageStatus = exports.WidgetPackageStatus || (exports.WidgetPackageStatus = {}));
var WidgetInstallEnv;
(function (WidgetInstallEnv) {
    WidgetInstallEnv["Dashboard"] = "dashboard";
    WidgetInstallEnv["Panel"] = "panel";
})(WidgetInstallEnv = exports.WidgetInstallEnv || (exports.WidgetInstallEnv = {}));
var WidgetRuntimeEnv;
(function (WidgetRuntimeEnv) {
    WidgetRuntimeEnv["Mobile"] = "mobile";
    WidgetRuntimeEnv["Desktop"] = "desktop";
})(WidgetRuntimeEnv = exports.WidgetRuntimeEnv || (exports.WidgetRuntimeEnv = {}));
//# sourceMappingURL=widget.js.map